import React from "react";
import "./Button.scss"
import arrow from "../../assets/arrow-white.svg"
const Button = ({ isPrimary = true, text, isArrow = true, width = "max-content", onClick }) => {
    return (
        <div className={isPrimary ? "PapayaButton-isPrimary" : "PapayaButton-isSec"}
            style={{ width }}
            onClick={onClick}>
            {text}
            {isArrow && <img alt="" src={arrow} className={isPrimary ? "PapayaButton-isPrimary-arrow" : "PapayaButton-isSec-arrow"} />}
        </div>
    )
}
export default Button